<template lang="pug">
.v-gallery.gallery
	v-modal-window.modal-window--gallery
		template(v-if="items && items.length")
			.gallery__slider
					v-image-slider(:data-source="{'items': items, 'buttons': buttons, 'remote': remote}"
							mode="gallery"
							:slidesCount="isSm ? mobileSlidesCount : null"
							:initial-index="initialIndex")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		initialIndex: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			buttons: null,
			remote: null,
			items: null,
			mobileSlidesCount: 1,
		};
	},

	methods: {
		dataSet(data) {
			this.items = data.items ?? null;
			this.buttons = data.buttons ?? null;
			this.remote = data.remote ?? null;
		}
	}
};
</script>